export enum ProdBuildState {
  ALL,
  TEST,
  NO_JOIN_ONLINE,
  ENQUIRY_TOUR_ONLY,
  NONE,
}

type ProdBuildStateOptions = {
  shouldBuildPage: (page: string) => boolean;
  shouldIncludeInLists: boolean;
  shouldIncludeInOnlineJoiningLists: boolean;
  shouldIncludeInClubFinder: boolean;
  shouldIncludeInEnquiryForms: boolean;
};

const options: Record<ProdBuildState, ProdBuildStateOptions> = {
  [ProdBuildState.ALL]: {
    shouldBuildPage: () => true,
    shouldIncludeInLists: true,
    shouldIncludeInOnlineJoiningLists: true,
    shouldIncludeInClubFinder: true,
    shouldIncludeInEnquiryForms: true,
  },
  [ProdBuildState.TEST]: {
    shouldBuildPage: () => true,
    shouldIncludeInLists: false,
    shouldIncludeInOnlineJoiningLists: false,
    shouldIncludeInClubFinder: false,
    shouldIncludeInEnquiryForms: false,
  },
  [ProdBuildState.NO_JOIN_ONLINE]: {
    shouldBuildPage: (page) => !page.includes('join-online'),
    shouldIncludeInLists: true,
    shouldIncludeInOnlineJoiningLists: false,
    shouldIncludeInClubFinder: true,
    shouldIncludeInEnquiryForms: true,
  },
  [ProdBuildState.ENQUIRY_TOUR_ONLY]: {
    shouldBuildPage: (page) => page.includes('enquire-now') || page.includes('book-a-tour'),
    shouldIncludeInLists: false,
    shouldIncludeInOnlineJoiningLists: false,
    shouldIncludeInClubFinder: true,
    shouldIncludeInEnquiryForms: true,
  },
  [ProdBuildState.NONE]: {
    shouldBuildPage: () => false,
    shouldIncludeInLists: false,
    shouldIncludeInOnlineJoiningLists: false,
    shouldIncludeInClubFinder: false,
    shouldIncludeInEnquiryForms: false,
  },
};

export const shouldBuildPageForProdBuildState = (page: string, prodBuildState: ProdBuildState) =>
  options[prodBuildState].shouldBuildPage(page);

export const shouldBuildClubPageForProdBuildState = (prodBuildState: ProdBuildState) =>
  shouldBuildPageForProdBuildState('/clubs', prodBuildState);

export const shouldIncludeInLists = (prodBuildState: ProdBuildState) =>
  options[prodBuildState].shouldIncludeInLists;

export const shouldIncludeInOnlineJoiningLists = (prodBuildState: ProdBuildState) =>
  options[prodBuildState].shouldIncludeInOnlineJoiningLists;

export const shouldIncludeInClubFinder = (prodBuildState: ProdBuildState) =>
  options[prodBuildState].shouldIncludeInClubFinder;

export const shouldIncludeInEnquiryForms = (prodBuildState: ProdBuildState) =>
  options[prodBuildState].shouldIncludeInEnquiryForms;
